import { Box, Container, Typography, Button, Stack, Card, CardContent, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { HeroSection } from '../../components/marketing/HeroSection';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const benefits = [
  'Making reservations',
  'Follow-up calls',
  'Research projects',
  'Scheduling appointments',
  'Data entry',
  'Customer service calls',
  'Travel planning',
  'Gift shopping',
];

export const PersonalAssistantsPage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <HeroSection
        title="Personal Assistants"
        subtitle="Real humans, based in the US, ready to help you today"
        variant="gradient"
      >
        <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 2 }}>
          <Chip label="🇺🇸 US-Based" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white' }} />
          <Chip label="100% Human" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white' }} />
          <Chip
            label="16+ Years in Business"
            sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 500 }}
          />
        </Stack>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/plans')}
          sx={{
            bgcolor: 'white',
            color: 'primary.main',
            '&:hover': { bgcolor: 'grey.100' },
          }}
        >
           Get Started
        </Button>
      </HeroSection>

      <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
        <Stack spacing={6}>
          <Box textAlign="center">
            <Typography variant="h4" gutterBottom fontWeight={600}>
                                                                     Real people who actually get things done
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
                                                                                                    Unlike AI chatbots, your Fancy Hands assistant is a real person based in the United
                                                                                                    States who understands context, uses judgment, and actually gets things done. We help
                                                                                                    with the little things so you can focus on the big picture.
            </Typography>
          </Box>

          <Card>
            <CardContent sx={{ p: { xs: 3, md: 5 } }}>
              <Typography variant="h5" gutterBottom fontWeight={600} textAlign="center">
                                                                                          What can we help with?
              </Typography>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                  gap: 2,
                  mt: 3,
                }}
              >
                {benefits.map((benefit) => (
                  <Stack key={benefit} direction="row" spacing={1.5} alignItems="center">
                    <CheckCircleIcon sx={{ color: 'success.main', fontSize: 20 }} />
                    <Typography>{benefit}</Typography>
                  </Stack>
                ))}
              </Box>
            </CardContent>
          </Card>

          <Card sx={{ bgcolor: 'primary.50', border: '1px solid', borderColor: 'primary.200' }}>
            <CardContent sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" fontWeight={600} gutterBottom>
                                                                       Why humans instead of AI?
              </Typography>
              <Typography variant="body2" color="text.secondary">
Some things just need a human touch.
Our assistants can navigate phone trees, form human connections, negotiate on your behalf, handle sensitive situations with
discretion, and adapt when things don't go as planned. No hallucinations, no
misunderstandings — just competent help from experienced professionals.
              </Typography>
            </CardContent>
          </Card>

          <Box textAlign="center">
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
              <Button variant="contained" size="large" onClick={() => navigate('/plans')}>
                                                                                            View Plans and Pricing
              </Button>
              <Button variant="outlined" size="large" onClick={() => navigate('/dedicated-assistant')}>
                                                                                                         Learn About Dedicated Assistants
              </Button>
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};
